export enum ColorVariantsDisplayType {
  grid = 'grid',
  slider = 'slider',
}
